import { IStoryBlokComponent } from "~interfaces/storyblock";
import React from "react";
import { IIconProps } from "~components/custom/icon";
import Components from "~components/components";
import { IText } from "~interfaces/components";
import styles from "./bullet-points.module.scss";
import { Accordion } from "@ef-global/web-ui-react";

export interface IBulletPointsItem extends IStoryBlokComponent {
  icon: Array<IIconProps>;
  title: IText;
  text: string;
  story: any;
}

export const BulletPointsItem = (props: IBulletPointsItem) => {
  const { icon, title, text, story, _uid } = props;
  const hasIcon = icon?.[0] ? true : null;

  return (
    <>
      <Accordion.Item
        key={_uid}
        icon
        className={`u-mb-xs u-show-s-only ${styles.accordionItem}`}
      >
        <Accordion.ItemTitle
          as={"h6"}
          icon
          inline
          className={`full-width u-mb-0`}
        >
          <div
            className={`${styles.bulletIcon} ${
              hasIcon ? "" : styles.bulletIconNoIcon
            }`}
          >
            {hasIcon && Components(icon[0], story)}
            <h6 className={styles.bulletTitle}>{title}</h6>
          </div>
        </Accordion.ItemTitle>
        <Accordion.ItemContent>
          <p>{text}</p>
        </Accordion.ItemContent>
      </Accordion.Item>
      <div key={_uid} className={`ef-col -s-12 -m-4 u-show-m-up u-mb-xl`}>
        {hasIcon && (
          <div className={styles.bulletIcon}>{Components(icon[0], story)}</div>
        )}
        <h6 className={styles.bulletTitle}>{title}</h6>
        <p>{text}</p>
      </div>
    </>
  );
};
